module.exports = __webpack_public_path__ + "img/group308.8dd0efe0.png";